// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.support.RentalManagerUserSupportWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserSupportWebApiHandler_getHelpArticles,
  RentalManagerUserSupportWebApiHandler_getHelpArticles_Path,
  RentalManagerUserSupportWebApiHandler_getHelpTopics,
  RentalManagerUserSupportWebApiHandler_getHelpTopics_Path,
  RentalManagerUserSupportWebApiHandler_submitRequest,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  GetHelpTopicListResponseV2Dto,
  RentalManagerSupportHelpArticlesResponseDto,
  RentalManagerUserSupportRequestV1Dto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface GetHelpArticlesParams {
  category?: string;
  topic?: string;
}

export type RentalManagerUserSupportWebApiHandler_getHelpArticles_Options = UseQueryOptions<
  RentalManagerSupportHelpArticlesResponseDto,
  unknown,
  RentalManagerSupportHelpArticlesResponseDto,
  readonly [string, GetHelpArticlesParams]
>;

const RentalManagerUserSupportWebApiHandler_getHelpArticles_GetKey = (getParams: GetHelpArticlesParams) =>
  [RentalManagerUserSupportWebApiHandler_getHelpArticles_Path, getParams] as const;

export const RentalManagerUserSupportWebApiHandler_getHelpArticles_queryOptions = (
  getParams: GetHelpArticlesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserSupportWebApiHandler_getHelpArticles_GetKey(getParams),
    queryFn: () => RentalManagerUserSupportWebApiHandler_getHelpArticles(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get help articles
 */
export const useRentalManagerUserSupportWebApiHandler_getHelpArticles = (
  getParams: GetHelpArticlesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserSupportWebApiHandler_getHelpArticles_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserSupportWebApiHandler_getHelpArticles_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserSupportWebApiHandler_getHelpArticles.getKey =
  RentalManagerUserSupportWebApiHandler_getHelpArticles_GetKey;

export type RentalManagerUserSupportWebApiHandler_getHelpTopics_Options = UseQueryOptions<
  GetHelpTopicListResponseV2Dto,
  unknown,
  GetHelpTopicListResponseV2Dto,
  readonly [string]
>;

const RentalManagerUserSupportWebApiHandler_getHelpTopics_GetKey = () =>
  [RentalManagerUserSupportWebApiHandler_getHelpTopics_Path] as const;

export const RentalManagerUserSupportWebApiHandler_getHelpTopics_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserSupportWebApiHandler_getHelpTopics_GetKey(),
    queryFn: () => RentalManagerUserSupportWebApiHandler_getHelpTopics(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get help topics with categories and outages
 */
export const useRentalManagerUserSupportWebApiHandler_getHelpTopics = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserSupportWebApiHandler_getHelpTopics_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserSupportWebApiHandler_getHelpTopics_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserSupportWebApiHandler_getHelpTopics.getKey =
  RentalManagerUserSupportWebApiHandler_getHelpTopics_GetKey;

export interface RentalManagerUserSupportWebApiHandler_submitRequest_Args {
  postData: RentalManagerUserSupportRequestV1Dto;
}

export type RentalManagerUserSupportWebApiHandler_submitRequest_Options = UseMutationOptions<
  string,
  unknown,
  RentalManagerUserSupportWebApiHandler_submitRequest_Args
>;

/**
 * Submit a support request
 */
export const useRentalManagerUserSupportWebApiHandler_submitRequest = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserSupportWebApiHandler_submitRequest_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserSupportWebApiHandler_submitRequest_Args) =>
      RentalManagerUserSupportWebApiHandler_submitRequest(args.postData, httpClient),
  });
};
